import { render, staticRenderFns } from "./submission-tab-questions.vue?vue&type=template&id=c62379d2&scoped=true&"
import script from "./submission-tab-questions.vue?vue&type=script&lang=ts&"
export * from "./submission-tab-questions.vue?vue&type=script&lang=ts&"
import style0 from "./submission-tab-questions.vue?vue&type=style&index=0&id=c62379d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62379d2",
  null
  
)

export default component.exports